import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './channel_tab_configuration.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import FloatingMenu from '../../../../moreCore/UI/Floating/Menu';
import channel_tab_create_projectCalendar from './create_projectCalendar/create_projectCalendar';
import create_generic_tab from './create_generic_tab/create_generic_tab';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';

class channel_tab_configuration extends compose(_WidgetBaseSP) {
    private myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private confirmDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    templateString: any = template;

    private mdscTabAppIsInstalledInTeams = false;

    private type2Data: Record<TabType,{icon:string, labelTranslation:string}> = {
        'generic': {
            icon: "far fa-square",
            labelTranslation:"MsTeamsIntegration_AdminPanel_TabConf_Table_Generic"
        },
        'projectCalendar': {
            icon: "far fa-handshake",
            labelTranslation:"MsTeamsIntegration_AdminPanel_TabConf_NewBtn_Label_ProjectCalendar"
        }
    };

    private currentEntity: { entityID: string, channelDisplayName: string, teamDisplayName:string } = null;
    private tableContainer:HTMLDivElement;
    private displayTable: MdsLax<InstanceType<typeof StaticTable>> = null;

    private newEntryFloatMenu: MdsLax<InstanceType<typeof FloatingMenu>> = null;

    private linkContainer:HTMLDivElement;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public loadChannelByEntityId(channelEntityID:string, channelDisplayName:string, teamDisplayName:string){
        this.currentEntity = {
            entityID: channelEntityID,
            channelDisplayName:channelDisplayName,
            teamDisplayName: teamDisplayName
        };
        this.reLoadData();
    }

    private async reLoadData(){
        this.ShowLoad();
        let reqProm:Promise<any> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_GetTabsForChannel",
                {
                    entityID:this.currentEntity.entityID ?? null
                },
                lang.hitch(this, (result:any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-exclamation-triangle");
                    reject(err);
                })
            );
        });

        let result: { tabs: Array<TeamsTabApiData>, tableLayout:Array<any> };
        try{
            result  = await reqProm;
        }catch(e){
            console.error(e);
            let errMsg = this.translate("General_Error") + ": could not fetch tab data from microsoft";
            this.showToast(errMsg, "fas fa-bug");
            return;
        }

        let originalMinHeight = this.tableContainer.style.minHeight;
        this.tableContainer.style.minHeight = (this.tableContainer.getBoundingClientRect().height ?? "0" ) + "px";

        if (this.displayTable != null){
            try{
                this.displayTable.destroyRecursive();
            }catch{}
            this.tableContainer.innerHTML = "";
        }
        this.displayTable = new StaticTable();
        this.displayTable.placeAt(this.tableContainer);
        this.displayTable.setFormatter(lang.hitch(this, this.table_formatter));
        this.displayTable.addDefaultRowActionButton('edit', lang.hitch(this, this.onTabEdit) as any);
        this.displayTable.addDefaultRowActionButton('delete', lang.hitch(this, this.onDeleteTab));
        this.displayTable.addCustomRowActionButton("openTeamsLink",
            (rowGroup: StaticTable.StaticTableRowGroup<TeamsTabApiData>) => {
                let targetUrl = rowGroup.entity?.tabWebUrl ?? "";
                if (typeof targetUrl == 'string'){
                    if (targetUrl.trim() != ""){
                        this.linkContainer.innerHTML = "";
                        const a = document.createElement("a");
                        a.href = targetUrl;
                        a.target = "_blank";
                        a.rel = "noopener";
                        a.style.display = "none";
                        this.linkContainer.appendChild(a);
                        a.click();
                        this.linkContainer.removeChild(a);
                    }
                }
            },
            "fas fa-external-link-alt",
            null,
            Number.MAX_SAFE_INTEGER,
            this.translate("MsTeamsIntegration_AdminPanel_OpenInTeams"),
            (entity: TeamsTabApiData)=>{
                if (typeof entity?.tabWebUrl == 'string') {
                    const urlRegex: RegExp = /^(?:https?:\/\/)?[^\s\/$.?#].[^\s]*$/i;
                    if (urlRegex.test(entity.tabWebUrl)) {
                        return true;
                    }
                }
                return false;
            },
            true
        );
        this.displayTable.setTableLayout(result.tableLayout?.[0]);
        this.displayTable.setData(result.tabs, "ID");
        this.HideLoad();
        this.tableContainer.style.minHeight = originalMinHeight;
    }

    private onTabEdit(rowGroup: StaticTable.StaticTableRowGroup<TeamsTabApiData>){
        let type = rowGroup.entity.tabSpecialType ?? 'generic';
        switch (type){
            case 'generic':
                let widgetSetupGenericTab = new create_generic_tab();
                widgetSetupGenericTab.showAsDlg(
                    this.currentEntity.entityID,
                    lang.hitch(this, this.onTabEditCallback_Generic)
                );
                widgetSetupGenericTab.setUpEdit(rowGroup.entity);
                this.createNewTabWidget = widgetSetupGenericTab;
                break;
            case 'projectCalendar':
                let widgetSetupProjectCalendar = new channel_tab_create_projectCalendar();
                widgetSetupProjectCalendar.showAsDlg(
                    this.currentEntity.entityID,
                    lang.hitch(this, this.onTabEditCallback_ProjectCalendar)
                );
                widgetSetupProjectCalendar.setUpEdit(rowGroup.entity);
                this.createNewTabWidget = widgetSetupProjectCalendar;
                break;
        }
    }
    private async onTabEditCallback_Generic(val:any){
        this.ShowLoad();

        let updateProm:Promise<void> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_generic_Update",
                val,
                lang.hitch(this, (result:any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    reject(err);
                })
            );
        });

        try{
            await updateProm;
        }catch(e){
            console.error(e);
        }

        this.HideLoad();
        this.reLoadData();
    }
    private async onTabEditCallback_ProjectCalendar(val:any){
        this.ShowLoad();

        let updateProm: Promise<void> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_ProjectCalendar_Update",
                val,
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    reject(err);
                })
            );
        });

        try {
            await updateProm;
        } catch (e) {
            console.error(e);
        }

        this.HideLoad();
        this.reLoadData();
    }

    private async onDeleteTab(rowGroup: StaticTable.StaticTableRowGroup<TeamsTabApiData>){
        let teamDN = this.currentEntity.teamDisplayName;
        let channelDN = this.currentEntity.channelDisplayName;
        let tabDN = rowGroup.entity.tabDisplayName;
        let msgTxt: string = this.translate("MsTeamsIntegration_AdminPanel_DeleteTab_InfoTxt") + "<br><br>";
        msgTxt += '<div class="displayInlineBlock">';
        msgTxt += '<i class="fas fa-users"></i> <span class="italic maxWidth32Ch" title="' + teamDN + '">' + teamDN + '</span>';
        msgTxt += '</div>';

        msgTxt += '<br><div class="displayInlineBlock">'
        msgTxt += '<i class="fas fa-angle-right paddingSmallLeft w3-padding-right"></i> ';
        msgTxt += '<i class="far fa-comments"></i> <span class="italic maxWidth32Ch" title="' + channelDN + '">' + channelDN + '</span>';
        msgTxt += '</div>'

        msgTxt += '<br><div class="displayInlineBlock">'
        msgTxt += '<i class="fas fa-angle-right paddingLeft w3-padding-right"></i> ';
        msgTxt += '<i class="fas fa-window-restore"></i> <span class="maxWidth32Ch" title="' + tabDN + '">' + tabDN + '</span>';
        msgTxt += '</div>'

        let targetId: string = rowGroup.entity.ID;
        if (this.confirmDlg != null){
            try{
                this.confirmDlg.destroyRecursive();
            }catch{}
        }
        this.confirmDlg = new GenericDialog();
        this.confirmDlg.setSize('smaller');
        this.confirmDlg.destroyOnClose = false;
        this.confirmDlg.show(
            msgTxt,
            this.translate("MsTeamsIntegration_AdminPanel_DeleteTab"),
            null,
            "fas fa-dumpster w3-xxxlarge w3-margin",
            'submitcancel',
            lang.hitch(this, (btnId: number) => {
                if (btnId == 1) {
                    //ok
                    this.deleteTab(targetId);
                } else {
                    this.reLoadData();
                }
            })
        );
    }
    private async deleteTab(targetId:string){
        this.ShowLoad();
        if (typeof targetId == 'string') {
            if (targetId.trim() != '') {
                let reqProm = new Promise((resolve, reject) => {
                    this.RequestManager.callfunction(
                        "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_DeleteTab",
                        { ID: targetId },
                        lang.hitch(this, (result: any) => {
                            resolve(result);
                        }),
                        lang.hitch(this, (err) => {
                            console.error(err.Message);
                            this.showToast(err.Message, "fas fa-bug");
                            reject(err);
                        })
                    );
                });

                let res: any;
                try {
                    res = await reqProm;
                } catch {
                    this.HideLoad();
                    this.reLoadData();
                    return;
                }
                console.info("deletedTab", res);
            }
        }
        this.HideLoad();
        this.reLoadData();
    }
    private table_formatter(cell: StaticTable.StaticTableCell<TeamsTabApiData>):boolean{

        switch (cell.name){
            case 'tabSpecialType':
                let targetType: TabType = cell.entity?.tabSpecialType ?? 'generic';
                if (Object.keys(this.type2Data).includes(targetType) == false){
                    targetType = 'generic';
                }

                cell.contentnode.innerHTML = "";

                let cont = document.createElement('div');

                let typeIco = document.createElement('i');
                typeIco.setAttribute("class", this.type2Data[targetType].icon);
                typeIco.classList.add("w3-padding-right");

                let typeLabel = document.createElement('span');
                typeLabel.classList.add("italic");
                typeLabel.innerHTML = this.translate(this.type2Data[targetType].labelTranslation);

                cont.appendChild(typeIco);
                cont.appendChild(typeLabel);
                cell.contentnode.appendChild(cont);
                return true;
                break;
        }
        return false;
    }


    private _onClick_NewBtn(ev:Event){
        if (this.newEntryFloatMenu != null){
            try{
                this.newEntryFloatMenu.destroyRecursive();
            }catch{}
        }
        this.newEntryFloatMenu = new FloatingMenu();
        this.newEntryFloatMenu.open(
            ev,
            [
                {
                    label: this.translate("MsTeamsIntegration_AdminPanel_TabConf_Table_Generic"),
                    enabled: true,
                    groupname: "general",
                    heading: this.translate("General_Label_General"),
                    icon: "far fa-plus-square",
                    callback: lang.hitch(this, () => {
                        this.onClick_createNewTab('generic');
                    })
                },
                {
                    label: this.translate("MsTeamsIntegration_AdminPanel_TabConf_NewBtn_Label_ProjectCalendar"),
                    enabled:this.mdscTabAppIsInstalledInTeams ?? false, //mdsc app wird benoetigt
                    groupname:"specialCalendar",
                    heading: this.translate("MsTeamsIntegration_AdminPanel_TabConf_NewBtn_Group_Calendar"),
                    icon:"far fa-handshake",
                    callback: lang.hitch(this, () => {
                        this.onClick_createNewTab('projectCalendar');
                    }),
                }
            ]
        );
    }

    private createNewTabWidget: MdsLax<InstanceType<typeof _WidgetBaseSP>> = null;
    private onClick_createNewTab(selectedTabType: TabType){
        if (this.createNewTabWidget != null){
            try{
                this.createNewTabWidget.destroyRecursive();
            }catch{}
        }
        switch( selectedTabType ){
            case 'generic':
                let widgetSetupGenericTab = new create_generic_tab();
                widgetSetupGenericTab.showAsDlg(
                    this.currentEntity.entityID,
                    lang.hitch(this, this.onCallback_createNewGenericTab)
                );
                this.createNewTabWidget = widgetSetupGenericTab;
                break;
            case 'projectCalendar':
                let widgetSetupProjectCalendar = new channel_tab_create_projectCalendar();
                widgetSetupProjectCalendar.showAsDlg(
                    this.currentEntity.entityID,
                    lang.hitch(this, this.onCallback_createNewProjectCalendar)
                );
                this.createNewTabWidget = widgetSetupProjectCalendar;
                break;
            default:
                console.error("not implemented", selectedTabType);
                break;
        }
    }

    private async onCallback_createNewGenericTab(reqVals:any){
        this.ShowLoad();
        let createGenericProm = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_generic_Create",
                reqVals,
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-exclamation-triangle");
                    reject(err);
                })
            );
        });

        try{
            await createGenericProm;
        }catch(e){
            console.error(e);
        }
        this.HideLoad();

        this.reLoadData();
    }

    private async onCallback_createNewProjectCalendar(reqVals: any)
     {
        this.ShowLoad();
        let reqProm = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_ProjectCalendar_Create",
                reqVals,
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    this.HideLoad();
                    reject(err);
                })
            );
        });

        let res: any = "";
        try {
            res = await reqProm;
        } catch (e) {
            console.error("Error creating projectCalendar", e);
            return;
        }
        this.HideLoad();
        console.info("created project calendar tab", res);
        this.reLoadData();
    }


    public setDlg(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        this.myDlg = dlg;
    }

    private ShowLoad(){
        this.StandbyStart();
        if (this.myDlg != null){
            this.myDlg.disableAllButtons(true);
        }
    }
    private HideLoad(){
        this.StandbyStop();
        if (this.myDlg != null){
            this.myDlg.disableAllButtons(false);
        }
    }

    public setMdscTabAppIsInstalled(mdscTabAppIsInstalledInTeams: boolean) {
        this.mdscTabAppIsInstalledInTeams = mdscTabAppIsInstalledInTeams;
    }

}

export default mdsWidget(channel_tab_configuration);
